import React from 'react';
import styles from './form.module.scss';
import Button from '../Button';
import { useTranslation } from "react-i18next";
const Thanks = ({ title, text, img, setShowThanks, errorRequest, errorTitle, errorText }) => {
  const [t] = useTranslation("global");

  return (
    <div className={`${styles.wrapper} ${styles.thanks} text-center`}>
      <div className={styles.skull}>
        <img src={img} alt={'skull'} />
      </div>
      <h3 className={styles.thanksTitle}>{!errorRequest ? title : errorTitle}</h3>
      <p className={`${styles.thanksText} text-large`}>{!errorRequest ? text: errorText}</p>
      <Button
        className={styles.button}
        text={!errorRequest ? t("buttons.nice") : t("buttons.ok")}
        view={'light'}
        onClick={() => setShowThanks(false)}
      />
    </div>
  );
};

export default Thanks;